<template>
    <div class="card card-sidebar" :class="{ 'card-sidebar-right': position === 'right' }">
        <div class="card-block" data-test-id="card-content">
            <slot />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        position: {
            type: String,
            default: "",
        },
    },
    // A `data` property is needed so that this file is taken into account by jest's code coverage
    // (cf. https://github.com/vuejs/vue-jest/issues/32)
    //
    data() {
        return {};
    },
};
</script>

<style scoped></style>
